import { render, staticRenderFns } from "./QyGroupDinnerConfigPane.vue?vue&type=template&id=352d1c50&scoped=true"
import script from "./QyGroupDinnerConfigPane.vue?vue&type=script&lang=js"
export * from "./QyGroupDinnerConfigPane.vue?vue&type=script&lang=js"
import style0 from "./QyGroupDinnerConfigPane.vue?vue&type=style&index=0&id=352d1c50&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352d1c50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('352d1c50')) {
      api.createRecord('352d1c50', component.options)
    } else {
      api.reload('352d1c50', component.options)
    }
    module.hot.accept("./QyGroupDinnerConfigPane.vue?vue&type=template&id=352d1c50&scoped=true", function () {
      api.rerender('352d1c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods_activity/qy_group_dinner/QyGroupDinnerConfigPane.vue"
export default component.exports